(function () {
  if (!document.documentElement.classList.contains('musayo-motion')) return;
  if (window.Shopify && Shopify.designMode) {
    document.documentElement.classList.remove('musayo-motion');
    return;
  }

  var SELECTOR = [
    '.hero-grid__tile',
    '.brand-strip__list',
    '.section-heading',
    '.product-card-wrapper',
    '.video-strip__item',
    '.collection-hero__title',
    '.template-search__title',
    '.collection-hero__description',
    '.product__info-wrapper',
    '.image-with-text',
    '.newsletter__wrapper',
  ].join(',');

  function settle(el) {
    el.addEventListener('animationend', function (event) {
      if (event.target !== el) return;
      el.classList.remove('musayo-rise', 'musayo-await', 'is-shown');
      el.style.animation = '';
      el.style.opacity = '';
      el.style.transform = '';
    });
  }

  var observer = new IntersectionObserver(onIntersect, {
    rootMargin: '0px 0px -6% 0px',
    threshold: 0.12,
  });

  var firstPass = true;

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-shown');
      settle(entry.target);
      observer.unobserve(entry.target);
    });
  }

  function arm(root) {
    if (!root || !root.querySelectorAll) return;
    var skipVisible = firstPass && document.documentElement.classList.contains('musayo-arrived');
    var nodes = Array.prototype.slice.call(root.querySelectorAll(SELECTOR));
    var buckets = new Map();

    nodes.forEach(function (el) {
      if (el.dataset.musayoMotion) return;
      if (el.closest('.header-wrapper, .cart-drawer, footer, .footer')) return;
      el.dataset.musayoMotion = '1';
      var key = el.closest('.product-grid, .hero-grid__grid, .video-strip__list, .collection-hero__inner') || el.parentElement;
      if (!buckets.has(key)) buckets.set(key, []);
      buckets.get(key).push(el);
    });

    buckets.forEach(function (list) {
      list.forEach(function (el, index) {
        el.style.setProperty('--musayo-i', String(Math.min(index, 6)));
        var rect = el.getBoundingClientRect();
        var inView = rect.bottom > 0 && rect.top < window.innerHeight * 0.94;
        if (inView && skipVisible) return;
        if (inView) {
          el.classList.add('musayo-rise');
          settle(el);
          return;
        }
        el.classList.add('musayo-await');
        observer.observe(el);
      });
    });
  }

  arm(document);
  firstPass = false;

  var grid = document.getElementById('ProductGridContainer');
  if (grid) {
    new MutationObserver(function () {
      arm(grid);
    }).observe(grid, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function (event) {
    arm(event.target);
  });

  var paired = null;

  function clearProductPair() {
    if (paired) {
      paired.style.viewTransitionName = '';
      paired = null;
    }
    document.querySelectorAll('.musayo-vt-product').forEach(function (el) {
      el.style.viewTransitionName = 'none';
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || (link.target && link.target !== '_self')) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;

      clearProductPair();

      if (!/\/products\/[^/?#]+/.test(url.pathname)) return;
      var scope = link.closest('.product-card-wrapper, .predictive-search__list-item');
      if (!scope) return;
      var target = scope.querySelector('.card__inner') || scope.querySelector('.card__media') || scope.querySelector('img');
      if (!target) return;
      var box = target.getBoundingClientRect();
      if (box.width < 8 || box.height < 8) return;
      target.style.viewTransitionName = 'musayo-product';
      paired = target;
    },
    true
  );

  window.addEventListener('pageswap', function (event) {
    if (!event.viewTransition) return;
    var type = event.activation && event.activation.navigationType;
    if (type === 'traverse') clearProductPair();
  });
})();
